import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import {PageLayout} from '@primer/react'
import type {FilesPageData} from '../page-data/payloads/files'
import type {HeaderPageData} from '../page-data/payloads/header'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {PullRequestFileTree} from '@github-ui/pull-request-file-tree/PullRequestFileTree'

export type FilesRoutePayload = FilesPageData & HeaderPageData

export function FilesEntrypoint() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Files />
    </ErrorBoundary>
  )
}

export function Files() {
  const data = useRoutePayload<FilesRoutePayload>()

  return <FilesComponent {...data} />
}

export function FilesComponent(props: FilesRoutePayload) {
  return (
    <>
      <PageLayout.Pane position="start" resizable padding="none" divider="line" sticky aria-label="File tree">
        <PullRequestFileTree {...props} />
      </PageLayout.Pane>
      <PageLayout.Content as="div" padding="normal" width="large">
        Diffs and Toolbar go here
      </PageLayout.Content>
    </>
  )
}

try{ FilesEntrypoint.displayName ||= 'FilesEntrypoint' } catch {}
try{ Files.displayName ||= 'Files' } catch {}
try{ FilesComponent.displayName ||= 'FilesComponent' } catch {}